import {POST} from "@/services/gateway";

const listItems = ({pagination, userIds, snapshotDateTime, folderId, searchTerm}) => {
  return POST('exchange/calendar/search', {pagination, userIds, snapshotDateTime, folderId, searchTerm});
}

const listCalendarBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('exchange/calendar/breadcrumbs', {userId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, code}) => {
  return POST('exchange/calendar/export', {snapshotDateTime, sourceIds, searchTerm, selectedIds}, {code: code ? code : null})
}

const restoreSnapshot = ({snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds, code}) => {
  return POST('exchange/calendar/restore', {snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds}, {code: code ? code : null})
}

export {
  listItems,
  listCalendarBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
